import React from 'react';
import Dialog from '@material-ui/core/Dialog';

const DialogComponent = ({ open, handleClose, children, className, hideCloseIcon }) => {
  return (
    <Dialog open={open} onClose={handleClose} className={`${className ? className : ''} react-dialog`}>
      {!hideCloseIcon ? <img src="src/assets/images/icons/close-button.svg" className="react-dialog-close" onClick={handleClose} alt="x"></img> : ''}
      {children}
    </Dialog>
  );
};

export default DialogComponent;
